import React, { useContext } from "react";

import { store } from "./lib/store";
import CustomerInformationForm from "./library/components/CustomerInformationForm/CustomerInformationForm";
import SpinLoader from "./library/components/spinner/spinner";

import "antd/dist/antd.css";
import "./App.css";

function App() {
  const { state, dispatch } = useContext(store);

  const setServiceType = (val) => {
    dispatch({ type: "updateServiceType", value: val });
  };

  return (
    <div className={`mnt-payment-form ${state.loading ? "loading" : ""}`}>
      {state.loading && <SpinLoader />}

      <h4>Select Service</h4>

      <div className="serviceOptions-container">
        <div
          className={`serviceOption ${
            state.serviceType === "auth-only" ? "selected" : ""
          }`}
          onClick={() => setServiceType("auth-only")}
        >
          <i class="x-icon-chevron-right" data-x-icon-s="&#xf054;"></i>{" "}
          Card Authentication Only : $40 / card
        </div>
        <div
          className={`serviceOption ${
            state.serviceType === "auth-grading" ? "selected" : ""
          }`}
          onClick={() => setServiceType("auth-grading")}
        >
         <i class="x-icon-chevron-right" data-x-icon-s="&#xf054;"></i>{" "}
         Card Authentication & Grading : $60 / card
        </div>
      </div>

      <h4>
        Service :
         {state.serviceType === "auth-only"
          ? " Card Authentication Only : $40"
          : " Card Authentication & Grading : $60"}{" "} 
      </h4>

      <h4>Card Details:</h4>
      <CustomerInformationForm />

    </div>
  );
}

export default App;
